import { useCallback, useEffect, useRef } from "react";

const FullScreenModal = ({ isOpen, onClose, children }: any) => {
  const ref = useRef<HTMLDialogElement>(null);

  const handleClose = useCallback(() => {
    ref.current?.close();
    document.body.style.overflow = "unset";
    onClose();
  }, [onClose]);

  useEffect(() => {
    if (isOpen) {
      if (!ref.current?.open) {
        ref.current?.showModal();
      }
      document.body.style.overflow = "hidden";
    }
  }, [isOpen, handleClose]);

  return (
    <dialog
      onClose={handleClose}
      ref={ref}
      className="w-[100vw] h-[100vh] max-w-none max-h-none m-auto bg-black"
    >
      {children}
    </dialog>
  );
};

export default FullScreenModal;
